import { compose } from 'redux';
import { curry } from 'lodash-es';
import { equals, propEq, propFromSelector } from '../utils';
import { jsonApi } from '../http-request';
import { INVITE_STATUSES } from '../../constants';
import * as inviteAddress from './invite-address.selectors';

const collection = jsonApi.selectors.collection('invites');
const findResource = jsonApi.findResource(collection);

const findResourceAndHydrate = curry((fn, state) =>
  compose(
    jsonApi.utils.hydrate(state),
    findResource(fn)
  )(state)
);

const createFacade = selector => {
  const propFromResource = propFromSelector(selector);

  const getAddressById = property => state =>
    compose(
      inviteAddress.hydrateFromFacade(state),
      inviteAddress.byId,
      propFromResource(property)
    )(state);

  return {
    id: propFromResource('id'),
    token: propFromResource('token'),
    email: propFromResource('email'),
    firstName: propFromResource('first_name'),
    lastName: propFromResource('last_name'),
    middleName: propFromResource('middle_name'),
    suffixName: propFromResource('suffix_name'),
    cellPhone: propFromResource('cell_phone'),
    homePhone: propFromResource('home_phone'),
    moveDate: propFromResource('move_date'),
    fromAddress: getAddressById('from_address_id'),
    toAddress: getAddressById('to_address_id'),
    isAnswered: compose(
      equals(INVITE_STATUSES.ANSWERED),
      propFromResource('status')
    ),
    uuid: propFromResource('uuid'),
  };
};

export const byToken = token =>
  createFacade(findResourceAndHydrate(propEq('attributes.token', token)));
